import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts"

interface GameHistoryChartProps {
  gameHistory: IMinifiedGameHistory
  dataType: "money" | "properties" | "cards" | "stock"
  title: string
  yAxisLabel: string
}

const GameHistoryChart: React.FC<GameHistoryChartProps> = ({
  gameHistory,
  dataType,
  title,
  yAxisLabel,
}) => {
  // Transform data for the chart
  const chartData = gameHistory.history.map((event, index) => {
    const dataPoint: any = {
      event: index + 1,
      turn: event.situation.turn,
    }

    // Add each player's data to the data point based on dataType
    event.situation.players.forEach((player) => {
      // Find the corresponding user data from constantData.users using email as identifier
      const userData = gameHistory.constantData.users.find(
        (user) => user.email === player.id
      ) as IUser | undefined

      const playerName = userData?.username || player.id

      // Get the appropriate data based on dataType
      let playerData: number
      switch (dataType) {
        case "money":
          playerData = player.money
          break
        case "properties":
          playerData = player.properties.length
          break
        case "cards":
          playerData = player.cards.length
          break
        case "stock":
          playerData = player.stock
          break
        default:
          playerData = 0
      }

      dataPoint[playerName] = playerData
    })

    return dataPoint
  })

  // Get unique users for legend
  const users = gameHistory.constantData.users

  // Define colors for each player
  const colors = [
    "#3B82F6",
    "#EF4444",
    "#10B981",
    "#F59E0B",
    "#8B5CF6",
    "#EC4899",
  ]

  return (
    <div className="bg-gray-800/50 border border-gray-600 rounded-lg p-4 w-full">
      <h4 className="text-white font-medium text-lg mb-4">{title}</h4>
      <div className="w-full h-[300px]">
        {/* @ts-ignore */}
        <ResponsiveContainer width="100%" height="100%">
          {/* @ts-ignore */}
          <LineChart data={chartData}>
            {/* @ts-ignore */}
            <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
            {/* @ts-ignore */}
            <XAxis
              dataKey="event"
              stroke="#9CA3AF"
              label={{ value: "Event", position: "insideBottom", offset: -5 }}
            />
            {/* @ts-ignore */}
            <YAxis
              stroke="#9CA3AF"
              label={{ value: yAxisLabel, angle: -90, position: "insideLeft" }}
            />
            {/* @ts-ignore */}
            <Tooltip
              contentStyle={{
                backgroundColor: "#1F2937",
                border: "1px solid #374151",
                borderRadius: "8px",
                color: "#F9FAFB",
              }}
            />
            {/* @ts-ignore */}
            <Legend />
            {users.map((user, index) => {
              const color = colors[index % colors.length]
              return (
                /* @ts-ignore */
                <Line
                  key={user.email}
                  type="monotone"
                  dataKey={user.username}
                  stroke={color}
                  strokeWidth={2}
                  dot={{ fill: color, strokeWidth: 2, r: 4 }}
                  activeDot={{
                    r: 6,
                    stroke: color,
                    strokeWidth: 2,
                  }}
                />
              )
            })}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}

export default GameHistoryChart
